import {inject} from "@angular/core";
import {catchError, map, of} from "rxjs";
import {CanActivateFn, RedirectCommand, Router} from "@angular/router";
import {SupervisorService} from "../../core/service/supervisor.service";

export const supervisorContractGuardFn: CanActivateFn = () => {
  const router = inject(Router);
  const supervisorService = inject(SupervisorService);
  const redirectTo = (url: string): RedirectCommand =>
    new RedirectCommand(router.parseUrl(url), {replaceUrl: true});

  return supervisorService.requiresContractCompletion().pipe(
    map(requiresContractCompletion =>
      requiresContractCompletion ? redirectTo('/supervisor-contract') : true
    ),
    catchError(() => of(redirectTo('/error')))
  );
};
